import { Box, formatDateTime, HStack, Text, WhiteCard } from '@elkaso-app/web-design';
import { IInvoiceScanDetailData } from 'apis/invoice-scanning';

interface ScanHeaderCardProps {
  scan: IInvoiceScanDetailData;
}

const InfoItem = ({ label, value }: { label: string; value?: string | null }) => (
  <Box minW='140px'>
    <Text fontSize='xs' color='gray.500'>
      {label}
    </Text>
    <Text fontWeight='medium'>{value || '---'}</Text>
  </Box>
);

export const ScanHeaderCard = ({ scan }: ScanHeaderCardProps) => {
  const formatAmount = (amount: number | null, currency: string | null) => {
    if (amount === null || amount === undefined) return '---';
    const formatted = amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return currency ? `${currency} ${formatted}` : formatted;
  };

  return (
    <WhiteCard p='lg'>
      <Text fontSize='xl' fontWeight='bold' mb='lg'>
        Invoice Scan #{scan.id}
      </Text>
      <HStack spacing='xl' flexWrap='wrap'>
        <InfoItem label='Invoice Number' value={scan.invoiceNumber} />
        <InfoItem label='Vendor' value={scan.vendorName} />
        <InfoItem label='Invoice Date' value={scan.invoiceDate} />
        <InfoItem label='Total Amount' value={formatAmount(scan.totalAmount, scan.currency)} />
        <InfoItem label='Subtotal' value={formatAmount(scan.subtotal, scan.currency)} />
        <InfoItem label='Tax' value={formatAmount(scan.taxAmount, scan.currency)} />
        <InfoItem label='Order ID' value={String(scan.orderId)} />
        <InfoItem label='Uploaded By' value={scan.uploadedByUser?.name} />
        <InfoItem label='Uploaded' value={scan.createdAt ? formatDateTime(scan.createdAt) : null} />
        <InfoItem label='Processed' value={scan.processedAt ? formatDateTime(scan.processedAt) : null} />
      </HStack>
    </WhiteCard>
  );
};
